import React from 'react'

import { certificates as certs } from '../CertsAndAppsArea/data'
import { metaSections } from '../ServicesArea/data'
import { items as contactItems } from '../ContactArea/data'

import Icon, { EIconId } from '../../../../components/icons'

import { TItem } from '../../types'

const certificates: TItem[] = [certs[0], certs[2], certs[3]]

const shippingTypes: TItem[] = [...metaSections[1].items]

const contactItem: TItem = {
  ...contactItems[0],
  icon: <Icon id={EIconId.HEADPHONE} className="w-40 flex-none mr-8" />,
}

export { certificates, shippingTypes, contactItem }
